export enum BusinessDomain {
  GENERAL = 'general',
  AGENT = 'agent',
  BROKER = 'broker',
  ADMIN = 'admin',
  SUBADMIN = 'subadmin',
}

export const businessDomainOptions = [
  { label: 'general', value: BusinessDomain.GENERAL },
  { label: 'agent', value: BusinessDomain.AGENT },
  { label: 'broker', value: BusinessDomain.BROKER },
  { label: 'admin', value: BusinessDomain.ADMIN },
  { label: 'subadmin', value: BusinessDomain.SUBADMIN },
];
